import React from 'react';
import { Alert, Badge, Card, Table } from 'react-bootstrap';
import { money } from '../lib/describe';
import {
  Counts,
  dateTime,
  errorText,
  LoadError,
  Loading,
  RefreshButton
} from '../components/Common';

const RunsTab = ({ data }) => (
  <Card>
    <Card.Header className="d-flex justify-content-between align-items-center">
      <h5 className="mb-0">Runs</h5>
      <RefreshButton onClick={data.refresh} loading={data.loading} />
    </Card.Header>
    <Card.Body className="p-0">
      {data.error && (
        <div className="p-3">
          <LoadError error={data.error} />
        </div>
      )}
      {data.loading ? (
        <Loading />
      ) : (
        <div className="table-responsive">
          <Table hover className="small align-middle mb-0">
            <thead>
              <tr>
                <th>Started</th>
                <th>Mode</th>
                <th>Scanned</th>
                <th>Outcomes</th>
                <th>Projected savings</th>
                <th>Duration</th>
                <th>Errors</th>
              </tr>
            </thead>
            <tbody>
              {data.runs.map(run => (
                <tr key={run.id || run.runId}>
                  <td>
                    {dateTime(run.startedAt)}
                    <div className="small text-muted text-break">
                      {run.runId || run.id}
                    </div>
                  </td>
                  <td>
                    <Badge bg={run.mode === 'dry-run' ? 'info' : 'warning'}>
                      {run.mode || '—'}
                    </Badge>
                  </td>
                  <td>{run.scanned ?? 0}</td>
                  <td>
                    <Counts counts={run.counts} />
                  </td>
                  <td>{money(run.projectedSavings)}</td>
                  <td>
                    {run.durationMs != null
                      ? `${(run.durationMs / 1000).toFixed(1)}s`
                      : '—'}
                  </td>
                  <td>
                    {run.errors?.length ? (
                      <details>
                        <summary className="text-danger">
                          {run.errors.length} errors
                        </summary>
                        {run.errors.map((err, i) => (
                          <Alert
                            key={i}
                            variant="danger"
                            className="small p-2 mt-2 mb-0 text-break"
                          >
                            {errorText(err)}
                          </Alert>
                        ))}
                      </details>
                    ) : (
                      '0'
                    )}
                  </td>
                </tr>
              ))}
              {!data.runs.length && (
                <tr>
                  <td colSpan={7} className="text-muted text-center p-4">
                    No runs recorded yet.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      )}
    </Card.Body>
  </Card>
);

export default RunsTab;
